export const ROW_HEIGHT_PADDING = 16;
export const SORT_TOGGLE_WIDTH = 2;

export const CELL_STATUS = {
  DISPLAY: "DISPLAY",
  EDIT: "EDIT",
  ADD: "ADD",
  UPDATING: "UPDATING",
};

export const FORM_STATUS = {
  DISPLAY: "DISPLAY",
  ADD: "ADD",
  CREATING: "CREATING",
  EDIT: "EDIT",
  UPDATING: "UPDATING",
};